import * as moment from 'moment';

import { Model } from './model';
import { Ship, QuotaItem } from './pojos';

class BatchLine extends Model {
  id: number;
  target_mode: string;

  constructor(values: Object = {}) {
    super(values);
  }
}

export class QuotaMovement extends Model {
  id: number;
  amount: number;
  creation_date: moment.Moment;
  external_entity: string;
  target_quota: QuotaItem = new QuotaItem();
  batch_line: BatchLine = new BatchLine();

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const quotaMovement = new QuotaMovement(values);

    if (values['target_quota']) {
      quotaMovement.target_quota = new QuotaItem(values['target_quota']);
    }

    if (values['batch_line']) {
      quotaMovement.batch_line = new BatchLine(values['batch_line']);
    }

    return quotaMovement;
  }

  public serialize() {
    const record = super.serialize();
    record['movement_amount'] = this.amount;
    if (this.target_quota && this.target_quota.id) {
      record['target_quota'] = this.target_quota.id;
    } else {
      record['target_quota'] = null;
    }
    return record;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quota-movement.ts